function supports(object: any, property: string): boolean {
    if (object !== null) {
        try {
            return property in object
        } catch (e) {
            return typeof object[property] !== 'undefined'
        }
    }
    return false
}

declare global {
    // tslint:disable-next-line: interface-name
    interface EventTarget {
        attachEvent(event: string, listener: EventListener): boolean
    }
}

export default function addListener(element: EventTarget, event: string, listener: EventListener, capture: boolean): void {
    if (supports(element, 'addEventListener')) {
        element.addEventListener(event, listener, capture)
    } else if (supports(element, 'attachEvent')) {
        element.attachEvent('on' + event, listener)
    }
}